import React from "react";

function BlockMiddleLayout2() {
  const sections = [
    { label: "", height: "33.3%" },
    { label: "SITTING AREA", height: "33.3%" },
    { label: "ENTRANCE", height: "33.3%" },
  ];

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        border: "1px solid black",
      }}
    >
      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            height: section.height,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom:
              index < sections.length - 1 ? "1px solid black" : "none",
          }}
        >
          <span style={{ fontWeight: "bold" }}>{section.label}</span>
        </div>
      ))}
    </div>
  );
}

export default BlockMiddleLayout2;
